export class Clients {
  constructor() {
    const clientsMore = document.querySelector('._clients__more');
    const clientsLess = document.querySelector('._clients__less');
    const clientsGrid = document.querySelectorAll('._clients .tm-client');

    clientsMore?.querySelector('a')?.addEventListener('click', e => {
        e.preventDefault();

        clientsMore.classList.add('hidden');
        clientsLess.classList.remove('hidden');

        clientsGrid.forEach(clientGrid => {
            clientGrid.classList.add('active');
        });
    });

    clientsLess?.querySelector('a')?.addEventListener('click', e => {
        e.preventDefault();

        clientsLess.classList.add('hidden');
        clientsMore.classList.remove('hidden');

        clientsGrid.forEach(clientGrid => {
            clientGrid.classList.remove('active');
        });
    });
  }
}

export default new Clients;
